import { render, staticRenderFns } from "./ServiceSequenceLayoutColumn.vue?vue&type=template&id=6c030741"
import script from "./ServiceSequenceLayoutColumn.vue?vue&type=script&lang=js"
export * from "./ServiceSequenceLayoutColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports